var _circle, _circle2, _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPageMstable(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 124,
    height: 124,
    viewBox: "0 0 124 124",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 62,
    cy: 62,
    r: 62,
    fill: "url(#paint0_linear_20431_57904)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 62,
    cy: 62,
    r: 62,
    fill: "url(#paint1_linear_20431_57904)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.3777 42.1319C32.3777 39.6789 32.228 37.2996 32.0034 34.8433H42.6916L43.0628 39.8328C44.251 38.1429 47.1516 34 54.6898 34C63.3476 34 65.8084 39.4512 66.5413 41.2886C69.6602 35.0742 74.7501 34.077 78.6331 34.077C86.243 34.077 89.3025 38.7586 90.1228 40.2913C92.1376 43.6678 91.9941 48.3462 91.9941 51.7228V72.9439H80.8817V50.8185C80.8817 46.6756 80.286 42.071 74.5411 42.071C67.898 42.071 67.7483 48.4393 67.7483 54.1951V72.9439H56.6296V50.5716C56.6296 47.5798 56.5549 42.0549 50.4357 42.0549C43.4963 42.0549 43.4963 48.1955 43.4963 50.8185V72.9439H32.3777V42.1319Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32 81.3439H92V90.7778H32V81.3439Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_20431_57904",
    x1: 62,
    y1: 0,
    x2: 62,
    y2: 124,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1479F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1360B3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_20431_57904",
    x1: 62,
    y1: 0,
    x2: 62,
    y2: 124,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#427BEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D5BB6"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPageMstable);
export default __webpack_public_path__ + "static/media/page-mstable.60e9715c7621a6ca8ed5ef34ca3205ae.svg";
export { ForwardRef as ReactComponent };